import styled from 'styled-components';

const LineBreak = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.24);
`;

export default LineBreak;
